import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { env } from '@/env';

let initialized = false;

/**
 * Boot the New Relic Browser (RUM) agent.
 *
 * Idempotent — safe to call from `main.tsx` and tests.
 */
export const setupBrowserAgent = (): void => {
  if (initialized) return;
  initialized = true;

  // No license key configured — skip instantiating the agent entirely.
  // Re-enable per env by setting the VITE_NEW_RELIC_* vars.
  if (!env.newRelic.licenseKey) return;

  new BrowserAgent({
    info: {
      applicationID: env.newRelic.applicationId,
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: env.newRelic.licenseKey,
      sa: 1,
    },
    init: {
      ajax: {
        deny_list: ['bam.nr-data.net'],
      },
      browser_consent_mode: {
        enabled: false,
      },
      distributed_tracing: {
        enabled: true,
      },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: {
        cookies_enabled: true,
      },
    },
    loader_config: {
      accountID: env.newRelic.accountId,
      agentID: env.newRelic.applicationId,
      applicationID: env.newRelic.applicationId,
      licenseKey: env.newRelic.licenseKey,
      trustKey: env.newRelic.trustKey,
    },
  });
};
